import { DateTimeFormatter } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';

export function DateTimeCell(props) {
  const { cell, type } = props;
  return cell.value ? (
    <DateTimeFormatter type="dateTime" date={cell.value} />
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}
